module.exports = __webpack_public_path__ + "static/media/portfolio7.da76ebb5.jpg";